/////////
// Date.getTime()
/////////
/*
The getTime() method of Date instances returns the number of milliseconds 
for this date since the epoch, which is defined as the midnight at the 
beginning of January 1, 1970, UTC.
*/
/////////////

/////////
// Date.now()
/////////
/*
The Date.now() static method returns the number of milliseconds elapsed since the epoch, 
which is defined as the midnight at the beginning of January 1, 1970, UTC.
*/
/////////////

////////
//Usefull notes
///////
/*
Range between two dates in days - timeLeft / (1000 * 60 * 60 * 24) (timeLeft in miliseconds)
Range between two dates in hours - timeLeft / (1000 * 60 * 60) (timeLeft in miliseconds)
Range between two dates in minutes - timeLeft / (1000 * 60) (timeLeft in miliseconds)
Range between two dates in seconds - timeLeft / (1000) (timeLeft in miliseconds)
*/
//////

//timeout.endDate must be UTC value!!!
export function setupTimeout(endDate) {
  const timeout = {
    endDate,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    expired: false,
    present: {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00'
    }
  }

  return {
    data: timeout,
    intervalId: setInterval(() => {
      var startDate = new Date(Date.now())
      var endDate = new Date(timeout.endDate)
      // console.log(startDate)
      // console.log(endDate)

      var timeLeft = new Date(endDate.getTime() - startDate.getTime())
      timeout.days = parseInt(timeLeft / (1000 * 60 * 60 * 24))
      timeout.hours = parseInt(timeLeft / (1000 * 60 * 60))
      while (timeout.hours > 23) {
        timeout.hours -= 24
      }
      timeout.minutes = parseInt(timeLeft / (1000 * 60))
      while (timeout.minutes > 59) {
        timeout.minutes -= 60
      }
      timeout.seconds = parseInt(timeLeft / (1000))
      while (timeout.seconds > 59) {
        timeout.seconds -= 60
      }

      timeout.present.days = `${timeout.days > 9 ? timeout.days : `0${timeout.days}`}` 
      timeout.present.hours = `${timeout.hours > 9 ? timeout.hours : `0${timeout.hours}`}` 
      timeout.present.minutes = `${timeout.minutes > 9 ? timeout.minutes : `0${timeout.minutes}`}` 
      timeout.present.seconds = `${timeout.seconds > 9 ? timeout.seconds : `0${timeout.seconds}`}`
      timeout.expired = timeout.days <= 0 && timeout.hours <= 0 && timeout.minutes <= 0 && timeout.seconds <= 0
    }, 1000)
  }
}
export function computeTimeAgo(date) {
  const timeout = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }
  var startDate = new Date(date)
  var endDate = new Date(Date.now())

  var timeLeft = new Date(endDate.getTime() - startDate.getTime())
  timeout.days = parseInt(timeLeft / (1000 * 60 * 60 * 24))
  timeout.hours = parseInt(timeLeft / (1000 * 60 * 60))
  while (timeout.hours > 23) {
    timeout.hours -= 24
  }
  timeout.minutes = parseInt(timeLeft / (1000 * 60))
  while (timeout.minutes > 59) {
    timeout.minutes -= 60
  }
  timeout.seconds = parseInt(timeLeft / (1000))
  while (timeout.seconds > 59) {
    timeout.seconds -= 60
  }

  return timeout
}